import { render, staticRenderFns } from "./HolidaySetting.vue?vue&type=template&id=ed0c89d8&scoped=true&"
import script from "./HolidaySetting.vue?vue&type=script&lang=js&"
export * from "./HolidaySetting.vue?vue&type=script&lang=js&"
import style0 from "./HolidaySetting.vue?vue&type=style&index=0&id=ed0c89d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0c89d8",
  null
  
)

export default component.exports